// The exceptions to the roles, in words (gap #18, roles.listScopes): an owner-only permission given to one
// person before roles held them, until when; and where a role limited to some places reaches. Riverstone's
// Grants.tsx and Blueprint's RolesPage.tsx draw them.
import { dateText } from '@flowology/kernel';

export interface Grant {
  staffId: string;
  permission: string;
  grantedBy: string;
  grantedAt: string;
  expiresAt: string | null;
}

/** "until Nov 1, 2026" or "no end date". */
export const untilText = (expiresAt: string | null, timeZone: string): string =>
  expiresAt ? `until ${dateText(expiresAt, timeZone)}` : 'no end date';

export interface RoleScope {
  staffId: string;
  roleKey: string;
  businessUnitIds: string[];
  locationIds: string[];
}

/** Where a limited role reaches: "Plumbing and Drains", "Plumbing, and 2 addresses", "1 address". */
export function reachText(s: RoleScope, unitName: (id: string) => string): string {
  const units = s.businessUnitIds.map(unitName);
  const unitsText =
    units.length > 2 ? `${units.slice(0, -1).join(', ')} and ${units.at(-1)}` : units.join(' and ');
  const n = s.locationIds.length;
  const places = n ? `${n} address${n === 1 ? '' : 'es'}` : '';
  return unitsText && places ? `${unitsText}, and ${places}` : unitsText || places;
}
